import { render, staticRenderFns } from "./ButtonsLoop.vue?vue&type=template&id=a2921594&"
import script from "./ButtonsLoop.vue?vue&type=script&lang=js&"
export * from "./ButtonsLoop.vue?vue&type=script&lang=js&"
import style0 from "./ButtonsLoop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports